import React, { useState } from 'react';

const QCMOptionToggle = ({ optionIndex, onToggle, isMarked = false }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        const newState = !isMarked;
        onToggle(optionIndex, newState);
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div className="relative">
            {/* Tooltip */}
            {isHovered && (
                <div className="absolute bottom-full right-0 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded shadow-lg z-10 whitespace-nowrap">
                    {isMarked ? "May be correct" : "Incorrect"}
                </div>
            )}
            
            {/* Toggle Button */}
            <button
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className={`
                    w-6 h-6 rounded-full border-2 transition-all duration-200
                    ${isMarked 
                        ? 'border-red-500 bg-red-500/20' 
                        : 'border-gray-600 bg-transparent hover:border-gray-500'
                    }
                    hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500/50
                `}
                title={isMarked ? "May be correct" : "Incorrect"}
            >
                {/* Icon - Simple dot or X */}
                <div className="w-full h-full flex items-center justify-center">
                    {isMarked ? (
                        <svg className="w-3 h-3 text-red-500" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.536-11.536a1 1 0 00-1.414-1.414L10 7.172 7.879 5.05a1 1 0 10-1.414 1.415L8.586 8.586l-2.12 2.121a1 1 0 101.414 1.414L10 10l2.121 2.121a1 1 0 001.415-1.414L11.414 8.586l2.122-2.122z" clipRule="evenodd" />
                        </svg>
                    ) : (
                        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full"></div>
                    )}
                </div>
            </button>
        </div>
    );
};

export default QCMOptionToggle;
